export default "__VITE_ASSET__DB4a$gD1__"